<script lang="ts" setup>
import { i18n } from '@/i18n';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';

const props = defineProps<{
  modalState: boolean;
}>();

const emits = defineEmits<{
  (e: 'close'): void;
  (e: 'remove'): void;
}>();

//変数
const t = i18n.t;
</script>

<template>
  <InfoModal
    :modal-state="modalState"
    :back-button-label="t('キャンセル')"
    :next-button-label="t('削除ボタンテキスト')"
    @on-back="emits('close')"
    @on-next="emits('remove')"
  >
    <template #title>{{ t('選択した取引を削除') }}</template>
    <template #description>
      {{ t('取引削除モーダルテキスト1') }}<br />
      {{ t('取引削除モーダルテキスト2') }}
    </template>
  </InfoModal>
</template>

<style lang="scss" scoped>
.add-group-modal-content {
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 24px;
}

.main-content {
  background-color: $backgroundDefault;
  border-radius: 8px;

  &__container {
    height: 100%;
    width: 100%;
    padding: 16px;
    display: grid;
    grid-template-rows: repeat(2, auto);
    gap: 8px;
  }

  &__title {
    font-size: 14px;
    font-weight: 400;
    color: $textDefault;
  }

  &__select-input {
    width: 100%;
    box-sizing: border-box;
    background-color: $semanticWhite;
    border-radius: 4px;
    border: 1px solid $borderDefault;
    font-size: 14px;
    font-weight: 400;
    color: $textDefault;
  }
}

::v-deep(.modal) {
  padding: 24px 40.5px;
}
</style>
